export default __webpack_public_path__ + "static/media/codes.d81a0709.png";